import React from 'react'
import TimeRangeSlider from '../main/ui/slider/TimeRangeSlider'
import { convertToTimeInputValue, maybeConvertToIntegerValue } from './time_range_slider_helpers'

const LiveTimeRangeSlider = props => {
  const max = maybeConvertToIntegerValue(props.value?.max, props.maxValue)
  const min = maybeConvertToIntegerValue(props.value?.min, props.minValue)

  const [value, setValue] = React.useState({ min, max })

  const maxInputFormElement = document.getElementById(props.maxInputId)
  const minInputFormElement = document.getElementById(props.minInputId)

  const handleChange = updatedValues => {
    const { max: updatedMax, min: updatedMin } = updatedValues

    if (maxInputFormElement) {
      maxInputFormElement.value = convertToTimeInputValue(updatedMax, props.maxValue)
    }

    if (minInputFormElement) {
      minInputFormElement.value = convertToTimeInputValue(updatedMin, props.minValue)
    }

    setValue(updatedValues)
  }

  return <TimeRangeSlider {...props} value={value} onChange={handleChange} />
}

export default LiveTimeRangeSlider
